/**
 * Копирование текста в буфер обмена с фолбэком для insecure-контекстов.
 * navigator.clipboard существует только в secure context (https/localhost) —
 * при открытии дев-сборки с мобильного по http://<IP> его нет вовсе, и без
 * фолбэка клик по «копировать» молча не делает ничего. Фолбэк — старый
 * execCommand('copy') через временный textarea.
 */
export const copyTextToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  // За экраном и readonly — чтобы на мобильных не прыгал вьюпорт и не
  // открывалась клавиатура
  textarea.style.position = 'fixed';
  textarea.style.top = '-1000px';
  textarea.style.opacity = '0';
  textarea.setAttribute('readonly', '');
  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, text.length);
  try {
    const succeeded = document.execCommand('copy');
    if (!succeeded) {
      throw new Error('execCommand copy failed');
    }
  } finally {
    document.body.removeChild(textarea);
  }
};
